import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import TestimonialTemplate from '@segment/templates/Testimonial'

const copy = {
  heading: `Analytics is crucial for product market fit`,
}

const Testimonial = () => {
  return (
    <StyledSectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase>
          <CopyText.Heading>{copy.heading}</CopyText.Heading>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <TestimonialTemplate company="y-combinator" />
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  max-width: 1060px;

  ${Section.Wrapper} {
    row-gap: 40px;
  }
`

export default Testimonial
